import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import DailyDetails from "./components/daily-details"
import Contributors from "modules/analyze-composite-factor-sensitivity-contributors"
import "./style.scss"
import { THRESHOLD_PARAMS } from "helpers/threshold"

function AnalyzeCompositeFactorSensitivityDetails({
  account,
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  segment,
  classifications,
  sortOrder,
  selectedDate,
  selectedContributorCategory,
  selectedContributorValue,
  selectedViewsFactors,
  details,
  viewType,
  expand,
  aggregation,
  mustAggregateFactors,
  factorsClassification,
  factorCategoryName,
  openFactorProfile,
  openSecurityProfile,
  currentGrouping,
  selectedOption,
  groupOrder,
  selectedViews,
  showNotHeld,
  base,
  baseSignature,
  setGrouping,
  setSortOrder,
  setGroupSortOrder,
  showContributorCategory,
  hideContributorCategory,
  showGroup,
  hideGroup,
  thresholdParams,
  factorSensitivityType,
  isActive,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return <div className={classnames("modules_analyze-composite-factor-sensitivity-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    {!selectedContributorCategory ? <DailyDetails {...{
      viewType,
      openFactorProfile,
      factorCategoryName,
      data: details,
      factorTable: true,
      show: showContributorCategory,
      groupSort: (order) => setGroupSortOrder({ ...groupOrder, order }),
      groupOrder,
      thresholdParams,
    }}
    /> : <Contributors {...{
      account,
      modelId,
      positionSetId,
      positionSetType,
      positionSetName,
      viewType,
      segment,
      classifications,
      expand,
      aggregation,
      mustAggregateFactors,
      factorsClassification,
      openSecurityProfile,
      openFactorProfile,
      selectedViewsFactors,
      selectedContributorCategory,
      selectedContributorValue,
      showContributorCategory,
      hideContributorCategory,
      currentGrouping,
      showGroup,
      hideGroup,
      sortOrder,
      sort: handleSort,
      selectedDate,
      selectedOption,
      details,
      groupOrder,
      selectedViews,
      showNotHeld,
      base,
      baseSignature,
      setGrouping,
      factorSensitivityType,
      isActive,
    }}
    />}
  </div>
}

AnalyzeCompositeFactorSensitivityDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  segment: PropTypes.object,
  classifications: PropTypes.array,
  aggregation: PropTypes.string,
  mustAggregateFactors: PropTypes.bool,
  factorsClassification: PropTypes.object,
  sortOrder: PropTypes.object.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  selectedDate: PropTypes.string,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number,
  factorSensitivity: PropTypes.array,
  details: PropTypes.array,
  viewType: PropTypes.string,
  selectedViewsFactors: PropTypes.array,
  expand: PropTypes.bool,
  factorCategoryId: PropTypes.string,
  factorCategoryName: PropTypes.string.isRequired,
  allCategoryItems: PropTypes.array.isRequired,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  currentGrouping: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  groupOrder: PropTypes.object.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedViews: PropTypes.array,
  showNotHeld: PropTypes.bool.isRequired,
  base: PropTypes.object,
  baseSignature: PropTypes.string,
  thresholdParams: THRESHOLD_PARAMS,
  factorSensitivityType: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
}

export default AnalyzeCompositeFactorSensitivityDetails
